import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Box from 'components/shared/Box';
import Divider from 'components/shared/Divider';
import ErrorBox from 'components/shared/ErrorBox';
import Icon from 'components/shared/Icon';
import IsOwner from 'components/shared/IsOwner';

import { UserContext } from 'components/shared/context/UserContextProvider';
import { ModalContext } from 'components/shared/context/ModalContextProvider';

import edit from 'images/edit.svg';

import Item from 'schema/item';

interface ItemListProps {
  items: Item[];
  searchValue: string;
}

interface ItemInnerContainerProps {
  isOwner: boolean;
}

const ItemName = styled.div`
  font-family: 'CircularStd-Medium';
  font-size: 15px;
`;

const ItemOuterContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px 0px;
`;

const ItemInnerContainer = styled.div<ItemInnerContainerProps>`
  display: grid;
  grid-template-columns: ${(props) => (props.isOwner ? '1fr 24px' : '1fr')};
  gap: 20px;

  align-items: center;
`;

const ItemList: React.FC<ItemListProps> = ({ items, searchValue }) => {
  const { userState } = useContext(UserContext);
  const { openEditItemModal } = useContext(ModalContext);

  const filteredItems = useMemo(
    () =>
      items.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase())
      ),
    [items, searchValue]
  );

  return items.length ? (
    filteredItems.length ? (
      <Box>
        {filteredItems.map((item, key) => (
          <ItemOuterContainer key={key}>
            {key !== 0 ? <Divider /> : null}
            <ItemInnerContainer isOwner={Boolean(userState.isOwner)}>
              <Link to={`/item/${item.id}`}>
                <ItemName>{item.name}</ItemName>
              </Link>
              <IsOwner>
                <Icon
                  src={edit}
                  onClick={() => {
                    openEditItemModal?.(item);
                  }}
                />
              </IsOwner>
            </ItemInnerContainer>
          </ItemOuterContainer>
        ))}
      </Box>
    ) : (
      <ErrorBox errorMessage="No items match this search" />
    )
  ) : (
    <ErrorBox errorMessage="No items yet" />
  );
};

export default ItemList;
